import React from "react";
import Header from "../components/Header";
import { useTranslation } from 'react-i18next';

export default function DelivStatus() {
    const { t } = useTranslation();

    return(
        <div>
            <div className="backGround bgBlue"></div>
            <Header type="cart" pageTitle={t(`Message.my_order_dlvy_info_title`)}/>

            <div className="delivStatusWr">
                <ul className="deliver">
                    <li>
                        <p className="cDisa">{t(`Message.my_order_dlvy_info_transport_doc_no`)}</p>
                        <p className="cBlack">456347067433</p>
                    </li>
                    <li>
                        <p className="cDisa">{t(`Message.my_order_dlvy_info_dlvy_company`)}</p>
                        <p className="cBlack">{t(`Message.my_order_dlvy_info_dlvy_company_nm`)}</p>
                    </li>
                </ul>
                <div className="delivStatus">
                    <ul className="dsUl">
                        <li>
                            <p className="dev1">세종중앙(집)</p>
                            <p className="dev2">2023-12-16 10:21</p>
                            <p className="dev3">배송완료되었습니다. (배송사원: 임경수 010-8978-4567)</p>
                        </li>
                        <li>
                            <p className="dev1">조치원 (세종20AUTO9)</p>
                            <p className="dev2">2023-12-16 10:21</p>
                            <p className="dev3">배송출발하였습니다. (배송사원: 임경수 010-8978-4567)</p>
                        </li>
                        <li>
                            <p className="dev1">Mega-Hub</p>
                            <p className="dev2">2023-12-16 10:21</p>
                            <p className="dev3">배송지점에 도착하여 배송을 준비중입니다.</p>
                        </li>
                        <li>
                            <p className="dev1">송탄터미널</p>
                            <p className="dev2">2023-12-16 10:21</p>
                            <p className="dev3">고객님 상품을 집하하여 송탄 터미널에 입고되었습니다.</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};